var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "contacts-table-wrap" },
    [
      _c("ve-table", {
        attrs: {
          "fixed-header": true,
          "max-height": "calc(100vh - 11.4rem)",
          "scroll-width": "187rem",
          columns: _vm.columns,
          "table-data": _vm.tableData,
          "border-around": false,
          "sort-option": _vm.sortOption
        }
      }),
      _vm._v(" "),
      _vm.showSearchEmptyState
        ? _c("empty-state", {
            attrs: { title: _vm.$t("CONTACTS_PAGE.LIST.404") }
          })
        : !_vm.isLoading && !_vm.contacts.length
        ? _c("empty-state", {
            attrs: { title: _vm.$t("CONTACTS_PAGE.LIST.NO_CONTACTS") }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "contacts--loader" },
            [
              _c("spinner"),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CONTACTS_PAGE.LIST.LOADING_MESSAGE")))
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }